import clsx from 'clsx'
import React from 'react'
import { useAppContext } from '../../../../../../redux/slices/appContext'
import FastAvatar from '../../../../../molecules/FastAvatar'
import { useGetClientQuery } from '../../../../VisualBalanceSheetV2/hooks'
import VisualBalanceEmptyState from '../../../../VisualBalanceSheetV2/VisualBalanceEmptyState'
import { VisualBlocksProps } from '../propTypes'
import { useVisualBlocksContext, VisualBlocksProvider } from '../VisualBlocksContext'
import { BlockDrilldown } from './BlockDrilldown'
import BlockItem from './BlockItem'
import { TreeBranch } from './TreeBranch'
import LoadingState from './LoadingState'

function VisualBlocksContent () {
  const { clientId } = useAppContext()
  const { data, isLoading, classNames, styles, maxBlockDepth, includeAvatar, ddItem } = useVisualBlocksContext()
  const { data: client } = useGetClientQuery(clientId)
  if (isLoading) {
    return <LoadingState />
  }

  if (!data?.length) {
    return (
      <div
        className={clsx(
          'flex flex-col gap-2 h-full items-center justify-center',
          classNames?.container
        )}
        style={{ minHeight: '500px', ...(styles?.container ?? {}) }}
      >
        <div className='w-full' style={{ maxWidth: '800px' }}>
          <VisualBalanceEmptyState />
        </div>
      </div>
    )
  } else if (ddItem != null) {
    return (
      <BlockDrilldown />
    )
  }

  return (
    <div
      data-id='visual-blocks-container'
      className={clsx('flex flex-row gap-2 w-full', classNames?.container)}
      style={{ minHeight: '500px', ...(styles?.container ?? {}) }}
    >
      {includeAvatar && (
        <>
          <div className='flex items-center'>
            <FastAvatar
              size='xl'
              avatarUrl={client?.avatarUrl}
              abbreviation={client?.clientAbbreviation}
            />
          </div>

          <TreeBranch />
        </>
      )}
      <div className='w-full'>
        <div className='flex flex-col gap-2 h-full w-full'>
          {data?.map((group) => (
            <React.Fragment key={group.id}>
              {group.isSeparated && (
                <div
                  className='my-4'
                  style={{
                    borderTop: '2px solid var(--color-neutral-300)',
                    marginRight: '165px'
                  }}
                />
              )}
              <BlockItem
                depth={0}
                {...group}
                labelLocation={maxBlockDepth <= 0 ? 'outside' : 'inside'}
                fixedWidth='200px'
                allocation={group.value / data.reduce((sum, item) => sum + item.value, 0)}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

function PipelineVisualBlocks (props) {
  return (
    <VisualBlocksProvider {...props}>
      <VisualBlocksContent />
    </VisualBlocksProvider>
  )
}

PipelineVisualBlocks.propTypes = VisualBlocksProps

export default PipelineVisualBlocks
